import React from 'react';
import { Spinner, Text } from '@datanomik/core-ui';
interface BlockScreenProps {
  openBlockScreen: boolean;
  className?: string;
  invisible?: boolean;
}

const BlockScreen = ({ openBlockScreen, className, invisible }: BlockScreenProps) => (openBlockScreen ? (
  <div
    role="presentation"
    className={`fixed inset-0 z-[9999999] flex flex-col items-center justify-center
      ${invisible ? 'opacity-0' : 'bg-[rgba(29,50,153,0.5)] text-white backdrop-blur-[3px]'}
      ${className ?? ''}`}
  >
    <Spinner tone="inherit" size={40} />
    <div className="dn-text">
      <Text>
        <span className="dot-collision" />
      </Text>
    </div>
  </div>
) : null);
export default BlockScreen;
